<template>
    <div id="hospManage">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>医院管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="margin:10px 0" align="left">
            <el-row :gutter="10">
                <el-col align="left" :span="16">
                    <el-button type="primary"  @click="addDialog = true" size="small">添加医院</el-button>
                </el-col>
                <el-col align="center" :span="7">
                    <el-input v-model="hospName" size="small" placeholder="医院名称" clearable @keyup.enter.native="query()"></el-input>
                </el-col>
                    <el-col align="center" :span="1">
                    <el-button icon="el-icon-search" size="small" circle @click="query()"></el-button>
                </el-col>
            </el-row>
        </div>
        <div>
            <template class="table">
                <el-table :data="hospList" ref="hospList"  style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" > </el-table-column>
                    <el-table-column prop="hospVo.hospName" align="center" label="医院名称" > </el-table-column>
                    <el-table-column prop="hospVo.hospCode" align="center" label="医院编号" > </el-table-column>
                    <el-table-column prop="hospVo.hospAdminName" align="center" label="医院负责人" > </el-table-column>
                    <el-table-column prop="hospVo.hospAdminTel" align="center" label="医院联系电话"></el-table-column>
                    <el-table-column prop="hospVo.receiveName" align="center" label="接诊咨询人"></el-table-column>
                    <el-table-column prop="hospVo.receiveTel" align="center" label="接诊咨询电话"></el-table-column>
                    <el-table-column prop="hospVo.hospRank" align="center" label="等级"></el-table-column>
                    <el-table-column prop="hospVo.hospAddr" align="center" label="地址"></el-table-column>
                    <el-table-column prop="saName" align="center" label="管理员" width="120"></el-table-column>
                    <el-table-column prop="" align="center" label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button @click="selectionChange(scope.row)" type="primary" size="small">医院管理</el-button>
                            <el-button @click="deleteHosp(scope.row)" type="danger" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="page">
            <el-pagination  :page-size="20" :page-count="5" :page-sizes="[10,20,50,100]" layout="total, prev, pager, next,sizes" :total="tablePage" @current-change='changePage' @size-change="changeSize" style="text-align:right"></el-pagination>
        </div>

        <!-- 添加医院弹窗 -->
        <el-dialog title="添加医院" v-dialogDrag :visible.sync="addDialog" :close-on-click-modal=false :close-on-press-escape=false width="660px" @close="closeDialog">
            <el-form :model="addForm" :rules="addHosp" ref="addForm" label-width="110px">
                <el-form-item label="医院名称" prop="hospName">
                    <el-input v-model="addForm.hospName" placeholder="医院名称" maxlength="25"></el-input>
                </el-form-item>
                <el-form-item label="医院负责人" prop="hospAdminName">
                    <el-input v-model="addForm.hospAdminName" placeholder="医院负责人"></el-input>
                </el-form-item>
                <el-form-item label="医院联系电话" prop="hospAdminTel">
                    <el-input v-model="addForm.hospAdminTel" placeholder="医院联系电话"></el-input>
                </el-form-item>
                <el-form-item label="接诊咨询人">
                    <el-input v-model="addForm.receiveName" placeholder="接诊咨询人"></el-input>
                </el-form-item>
                <el-form-item label="接诊咨询电话" prop="receiveTel">
                    <el-input v-model="addForm.receiveTel" placeholder="接诊咨询电话"></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="hospAddArr">
                    <city-select @hospAddArr='addArr=>{addForm.hospAddArr=addArr}' :hospCityArr='addForm.hospAddArr' style="width:100%;" />
                </el-form-item>
                <el-form-item label="详细地址" prop="hospAddr">
                    <el-input v-model="addForm.hospAddr" placeholder="详细地址"></el-input>
                </el-form-item>
                <el-form-item label="等级" prop="hospRank">
                    <el-select v-model="addForm.hospRank" placeholder="等级" style="width:100%">
                        <el-option v-for="item in hospRanks" :label="item.dictDesc" :value="item.dictDesc" :key="item.dictDesc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医院简介">
                    <el-input v-model="addForm.hospDesc" type="textarea" :rows="4" placeholder="医院简介"></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="cancel()">取 消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </el-dialog>

    </div>
</template>

<script>
import hospImg from '@/assets/hospital.jpg'
import aliUploade from '@/components/upLoad'
import citySelect from '@/components/city'
import {isvalidPhone,isvalidCallAndPhone} from '@/service/common'
import { Loading } from 'element-ui'
//定义一个全局的变量，手机号格式验证
var validPhone=(rule, value,callback)=>{
    if (value=='' || value==null || value==undefined){
        callback()
    }else if (!isvalidCallAndPhone(value)){
        callback(new Error('请输入正确的电话号或手机号'))
    }else {
        callback()
    }
}
//定义一个全局的变量，手机号格式验证
var validHospPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入电话号码'))
    }else  if (!isvalidCallAndPhone(value)){
        callback(new Error('请输入正确的电话号或手机号'))
    }else {
        callback()
    }
}
export default {
    name:'hospManage',
    components:{
      'ali-uploade':aliUploade,
      'city-select':citySelect
    },
    props: {
      multiple: {
          type: Boolean,
          twoWay: false
      },
      id: {
          type: String,
          twoWay: false,
      },
      urls: {
          type: Array,
          twoWay: true
      }
    },
    data(){
        return{
            userInfo:'',
            city:[],//城市json数据
            propAdd:{
                value: 'value',
                children: 'cities'
            },
            numArr:[],
            addDialog : false,
            addForm : {
                hospName:'',
                hospAddr:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
                receiveName:'',
                receiveTel:'',
                hospRegionCode:'',
                hospAddArr:[]
            },
            tablePage : 15,
            hospList:[],
            //查询医院名称
            hospName:'',
            page:1,
            rows:20,
            addHosp:{
                hospName:[{ required: true, message: '请输入医院名称', trigger: 'blur' }],
                hospAdminTel:[{ required: true, trigger: 'blur', validator: validHospPhone }],
                receiveTel:[{ required: false, trigger: 'blur', validator: validPhone }],
                hospAdminName:[{ required: true, message: '请输入医院负责人', trigger: 'blur' }],
                hospAddr:[{ required: true, message: '请输入医院地址', trigger: 'blur' }],
                hospAddArr:[{ required: true, message: '请选择地区Code', trigger: 'blur' }],
                hospRank:[{ required: true, message: '请选择医院等级', trigger: 'blur' }]
            },
            addAdminFormRules:{
                userName:[{required: true, message: '请输入管理员姓名', trigger: 'blur'}],
                userTel:[{required: true, message: '请输入管理员电话', trigger: 'blur'}],
                password:[{required: true, min:6, message: '密码不能少于6位', trigger: 'blur'}]
            },
            hospRanks:[],
            loadingInstance:''
        }
    },
    mounted(){
        this.getHospList();
        this.listHospRank()
    },
    methods:{
        //获取医院等级列表
        listHospRank(){
            this.$ajax.post(this.$domain.listHospRank)
            .then((ret)=>{
                this.$common.getConsole('hospManage.vue——获取医院等级列表',ret.data);
                var res=ret.data
                if(res.code=="200"){
                    console.log(res.data)
                    this.hospRanks=res.data
                }
            })
        },
        closeDialog(){
            this.numArr=[];
            this.addForm= {
                hospName:'',
                hospAddr:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
                receiveName:'',
                receiveTel:'',
                hospAddrId:'',
                hospAddArr:[]
            }
            this.$refs['addForm'].resetFields();
        },
        //获取医院列表(OK)
        getHospList(){
            var obj={
                page:this.page,
                rows:this.rows,
                hospName:this.hospName
            }
            this.$ajax.post(this.$domain.listHosp,obj)
            .then(ret=>{
                var res=ret.data
                this.$common.getConsole('hospManage——获取医院列表',res);
                if(res.code=="200"){
                    this.hospList=res.data.list;
                    this.tablePage=res.data.count;
                }
            })

        },
        // 医院管理
        selectionChange(row){
            this.$common.setStorage('hospMsg',row.hospVo);
            this.$router.push({path:'hospDetail'})
        },
        // 确认添加医院
        save(){
            this.addForm.hospRegionCode=this.addForm.hospAddArr[this.addForm.hospAddArr.length-1];
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.loadingInstance=Loading.service({
                        text:'医院添加中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                   this.$ajax.post(this.$domain.addHosp,this.addForm)
                    .then(ret=>{
                        console.log(ret.data);
                        this.loadingInstance.close();
                        var res=ret.data
                        if(res.code=="200"){
                            this.$message.success('添加成功！');
                            this.cancel();
                            this.hospName=''
                            this.getHospList();
                        }
                        else{
                            this.$message.error('添加失败！');
                        }
                    })
                    .catch(err=>{
                        this.loadingInstance.close();
                    })
                }
            })

        },
        openEdit(row){
            if(row==undefined){
                this.$message.error('请选中数据！');
                return;
            }
            this.updateForm={
                hospName:row.hospName,
                hospAdminTel:row.hospAdminTel,
                hospAdminName:row.hospAdminName,
                receiveName:row.receiveName,
                receiveTel:row.receiveTel,
                hospRegionAddr:row.hospRegionAddr,
                hospAddr:row.hospAddr,
                hospRank:row.hospRank,
                hospDesc:row.hospDesc,
                hospId:row.hospId
            };
            this.updateDialog=true;
        },
        // 保存修改医院信息
        update(){
            this.loadingInstance=Loading.service({
                text:'医院信息保存中...',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$ajax.post(this.$domain.updateHosp,this.updateForm)
            .then(ret=>{
                this.loadingInstance.close();
                var res=ret.data
                if(res.code=="200"){
                    this.$message.success('修改成功！');
                    this.cancel();
                    this.getHospList();
                }
                else{
                    this.$message.error('修改失败！');
                }
            })
            .catch(err=>{
                this.loadingInstance.close();
            })
        },
        // 翻页(OK)
        changePage(val){
            this.page=val
            this.getHospList()
        },
        
        changeSize(val){
            this.rows=val
            this.getHospList()
        },
        // 取消,清空表单 隐藏dialog
        cancel(){
            this.addForm = {
                hospName:'',
                hospAddr:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
                hospAddrId:'',
                hospAddArr:[]
            };
            // this.$refs['addForm'].resetFields();
            this.updateForm = {};
            this.addAdminForm = {};
            this.updateAdminForm = {};
            this.addDialog = false;
            this.updateDialog = false;
            this.addAdminDialog = false;
            this.updateAdminDialog = false;
        },
        //条件查询医院(OK)
        query(){
            this.page=1
            this.getHospList()
        },
        tel(row){
            return row.hospAdminTel.substring(0,3)+"****"+row.hospAdminTel.substring(7,11)
        },
        deleteHosp(row){
            this.$confirm('此操作将永久删除该医院, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.post(this.$domain.deleteHosp,{
                    hospId:row.hospVo.hospId
                })
                .then(ret=>{
                    this.$common.getConsole('hospManage.vue——删除医院',ret.data)
                    if(ret.data.code==200){
                        this.$message.success('医院删除成功！');
                        this.getHospList();
                    }
                    else{
                        this.$message.error(ret.data.message);
                    }
                })
            })
        }
    },
    directives: {
        dialogDrag:{
            bind(el, binding, vnode, oldVnode) {
                const dialogHeaderEl = el.querySelector('.el-dialog__header');
                const dragDom = el.querySelector('.el-dialog');
                //dialogHeaderEl.style.cursor = 'move';
                dialogHeaderEl.style.cssText += ';cursor:move;'
                dragDom.style.cssText += ';top:0px;'

                // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
                const sty = (function() {
                    if (window.document.currentStyle) {
                        return (dom, attr) => dom.currentStyle[attr];
                    } else{
                        return (dom, attr) => getComputedStyle(dom, false)[attr];
                    }
                })()

                dialogHeaderEl.onmousedown = (e) => {
                    // 鼠标按下，计算当前元素距离可视区的距离
                    const disX = e.clientX - dialogHeaderEl.offsetLeft;
                    const disY = e.clientY - dialogHeaderEl.offsetTop;

                    const screenWidth = document.body.clientWidth; // body当前宽度
                    const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

                    const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
                    const dragDomheight = dragDom.offsetHeight; // 对话框高度

                    const minDragDomLeft = dragDom.offsetLeft;
                    const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

                    const minDragDomTop = dragDom.offsetTop;
                    const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;


                    // 获取到的值带px 正则匹配替换
                    let styL = sty(dragDom, 'left');
                    let styT = sty(dragDom, 'top');

                    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
                    if(styL.includes('%')) {
                        styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100);
                        styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100);
                    }else {
                        styL = +styL.replace(/px/g, '');
                        styT = +styT.replace(/px/g, '');
                    };

                    document.onmousemove = function (e) {
                        // 通过事件委托，计算移动的距离
                        let left = e.clientX - disX;
                        let top = e.clientY - disY;

                        // 边界处理
                        if (-(left) > minDragDomLeft) {
                            left = -(minDragDomLeft);
                        } else if (left > maxDragDomLeft) {
                            left = maxDragDomLeft;
                        }

                        if (-(top) > minDragDomTop) {
                            top = -(minDragDomTop);
                        } else if (top > maxDragDomTop) {
                            top = maxDragDomTop;
                        }

                        // 移动当前元素
                        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
                    };

                    document.onmouseup = function (e) {
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                }
            }
        }
    }
}
</script>

<style>
    .hospImg{
        width:120px;
        height:120px;
        border-radius: 50%;
    }
    #hospManage{
        width:100%;
        min-width: 1200px;
        padding:0 10%;
        box-sizing: border-box;
    }
    #hospManage .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    .el-table .selected-row{
        background:#cee3e9
    }
    #hospManage .el-cascader{
        width:100%;
    }
    .hospPic{
        height:100px;
        margin-right:20px;
    }
    .el-form-item__content{
        margin-left:0 !important;
        display: flex;
        justify-content: flex-start
    }
    .adminInfo{
        width:80%;
        height:32px;
        border-bottom:1px solid #ccc;
        text-align: left;
        padding-left:2px
    }
</style>



// WEBPACK FOOTER //
// src/page/hospManage.vue